import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import constants from '../../../../constants';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/registerChangeRequest/registerUseCase';
import routes from '../../../../../../components/Routes/routingMap';
import ChangeStudiesOptionInfoView from './ChangeStudiesOptionInfoView';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const ChangeStudiesOptionInfoViewController = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const history = useHistory();
  const [processAvailable, setProcessAvailable] = useState(false);
  const [disabledStudyOption, setDisabledStudyOption] = useState(false);
  const [isCurrentProcess, setIsCurrentProcess] = useState(false);
  const [isRequestInProgress, setRequestInProgress] = useState(false);
  const [isReincorporatedModal, setIsReincorporatedModal] = useState(false);

  const {
    procedure: procedureSelectedInfo,
    isLoading,
    selectedProcedureId
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  React.useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-changeStudiesOption', 'portal');
    dispatch(registerActions.registerChangeClear());
    if (!procedureSelectedInfo && !isLoading) {
      const selectedRequest: any =
        constants.categories.requests.procedureList.find(
          (p: any) => p.url === params.changeStudiesOption
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedRequest?.procedureId ||
            constants.categories.requests.procedures.changeOfStudyOptionModality
        )
      );
    }
  }, []);

  const handlerRequest = () => {
    if (procedureSelectedInfo.disabled === true) {
      setDisabledStudyOption(true);
      return;
    }
    if (procedureSelectedInfo.currentRequestId !== 0) {
      setIsCurrentProcess(true);
      return;
    }
    if (procedureSelectedInfo.requestInProgress === true) {
      setRequestInProgress(true);
      return;
    }

    if (procedureSelectedInfo.isReincorporated === true) {
      setIsReincorporatedModal(true);
      return;
    }
    if (procedureSelectedInfo.error) {
      setProcessAvailable(true);
      return;
    }
    history.push(
      routes.student.procedures.categories.requests.changeStudiesOption
        .procedureregister
    );
  };

  const handlerCloseModalRequestInProgress = () => {
    setRequestInProgress(false);
  };

  const handleCloseModalProcessAvailable = () => {
    setProcessAvailable(false);
  };

  const hanlderCloseDisabledStudyOption = () => {
    setDisabledStudyOption(false);
  };

  const handlerCloseCurrentProcess = () => {
    setIsCurrentProcess(false);
  };

  const handlerCloseIsReincorporatedModal = () => {
    setIsReincorporatedModal(false);
  };

  const goBack = () => history.goBack();

  if (
    selectedProcedureId !== undefined &&
    !procedureWhiteList?.includes(selectedProcedureId?.toString())
  ) {
    history.push(routes.student.procedures.home);
  }

  return (
    <ChangeStudiesOptionInfoView
      procedureSelectedInfo={procedureSelectedInfo}
      handlerRequest={handlerRequest}
      processAvailable={processAvailable}
      handleCloseModalProcessAvailable={handleCloseModalProcessAvailable}
      disabledStudyOption={disabledStudyOption}
      hanlderCloseDisabledStudyOption={hanlderCloseDisabledStudyOption}
      isCurrentProcess={isCurrentProcess}
      handlerCloseCurrentProcess={handlerCloseCurrentProcess}
      isReincorporatedModal={isReincorporatedModal}
      handlerCloseIsReincorporatedModal={handlerCloseIsReincorporatedModal}
      goBack={goBack}
      isRequestInProgress={isRequestInProgress}
      handlerCloseModalRequestInProgress={handlerCloseModalRequestInProgress}
    />
  );
};

export default ChangeStudiesOptionInfoViewController;
